module.exports = __webpack_public_path__ + "./images/3efe8168b757d728b8cb43bc2c2b3cd2.webp";